import React from "react";
import { MobXProviderContext } from "mobx-react";
import { AppStore } from "store/App.store";

export function useAppStore(): AppStore {
  return React.useContext(MobXProviderContext).store;
}
